/* Scope layout adjustments to the homepage. Never alter an expanded app panel. */
(() => {
  if (!document.querySelector('main[data-template="index"]')) return;
  const root = document.documentElement;
  const syncInput = () => root.classList.toggle('cgau-home-input-active', !!document.activeElement?.matches('input,textarea,select,[contenteditable="true"]'));
  document.addEventListener('focusin', syncInput);
  document.addEventListener('focusout', () => requestAnimationFrame(syncInput));
  let bound;
  const previousPositions = new WeakMap();
  const collapsedBottom = 'max(12px, env(safe-area-inset-bottom))';
  const placeBadge = () => {
    const badge = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (!badge) return;
    const collapsed = parseFloat(badge.style.width) <= 180 && parseFloat(badge.style.height) <= 180;
    badge.dataset.cgauCollapsed = String(collapsed);
    if (collapsed && badge.style.bottom !== collapsedBottom) {
      previousPositions.set(badge, {value:badge.style.bottom, priority:badge.style.getPropertyPriority('bottom')});
      badge.style.setProperty('bottom', collapsedBottom, 'important');
    } else if (!collapsed && previousPositions.has(badge)) {
      const previous = previousPositions.get(badge);
      // Restore only our value. The app may already have positioned its open panel.
      if (badge.style.bottom === collapsedBottom) {
        if (previous.value) badge.style.setProperty('bottom', previous.value, previous.priority);
        else badge.style.removeProperty('bottom');
      }
      previousPositions.delete(badge);
    }
    if (bound !== badge) {
      bound = badge;
      new MutationObserver(placeBadge).observe(badge, {attributes:true,attributeFilter:['style']});
    }
  };
  placeBadge();
  if (!bound) {
    const observer = new MutationObserver(() => { placeBadge(); if (bound) observer.disconnect(); });
    observer.observe(document.body, {childList:true,subtree:true});
    window.setTimeout(() => observer.disconnect(),15000);
  }
})();
